import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { usePartnrConfirmStore } from '@/stores/partnrConfirmStore';

const MAX_LISTED = 8;

/** Confirmation for destructive or costly Partnr actions (deleting items, paid extension runs). */
export function PartnrConfirmDialog() {
  const request = usePartnrConfirmStore((s) => s.request);
  const answer = usePartnrConfirmStore((s) => s.answer);

  return (
    <AlertDialog open={!!request} onOpenChange={(open) => { if (!open) answer(false); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{request?.title}</AlertDialogTitle>
          <AlertDialogDescription>{request?.description}</AlertDialogDescription>
        </AlertDialogHeader>
        {request && request.items.length > 0 && (
          <ul className="max-h-48 overflow-y-auto rounded-md border bg-muted/40 px-4 py-2 text-sm">
            {request.items.slice(0, MAX_LISTED).map((label, i) => (
              <li key={i} className="truncate py-0.5">{label}</li>
            ))}
            {request.items.length > MAX_LISTED && (
              <li className="py-0.5 text-muted-foreground">and {request.items.length - MAX_LISTED} more</li>
            )}
          </ul>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => answer(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className={request?.destructive === false ? undefined : 'bg-destructive text-destructive-foreground hover:bg-destructive/90'}
            onClick={() => answer(true)}
          >
            {request?.confirmLabel ?? 'Confirm'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
